import { AlertType } from '../types/Alert/AlertType';
import { ErrorResponseType } from '../types/Error/ErrorResponseType';
import React from 'react';

export const AlertContext = React.createContext<{
  setAlert: React.Dispatch<React.SetStateAction<ErrorResponseType | AlertType | string | null>>;
}>({
  setAlert: () => null
});
